// Outbound destinations, in one place.
//
// The Nizro signup URL is used from /nizro (pages/NizroPage.js) and, in
// future, anything else that links to the product — one place so a domain
// change never ends up half-applied.
export const NIZRO_URL = 'https://www.nizro.app';

// The product reads `?lang=` on arrival and persists it in its locale cookie,
// so a visitor reading this site in Arabic lands on an Arabic signup form and
// stays in Arabic afterwards (and likewise for English). Always build the
// signup link through this helper — a bare /signup link loses the language.
export const nizroSignupUrl = (lang) => `${NIZRO_URL}/signup?lang=${lang === 'ar' ? 'ar' : 'en'}`;

// nizro.app serves Arabic at the root and English under /en, and every page
// below follows the same split: /solutions/<trade>, /fawtara.
export const nizroHomeUrl = (lang) => (lang === 'ar' ? NIZRO_URL : `${NIZRO_URL}/en`);
export const nizroPageUrl = (lang, page) => `${nizroHomeUrl(lang)}/${page}`;
